import { useEffect } from 'react'
import { type TabRootStore, useTabRoot } from '../TabRootStore'
import { MessageToRoot } from '../utils'

function findSourceTab(tabRoot: TabRootStore, source: MessageEventSource | null) {
  if (source == null) return null

  const iframes = Array.from(document.querySelectorAll('iframe'))
  for (const iframe of iframes) {
    if (iframe.contentWindow === source) {
      return tabRoot.tabs.find((entry) => entry.uuid === iframe.dataset.uuid)
    }
  }
}

export const useHandleMessageToRoot = () => {
  const tabRoot = useTabRoot()
  useEffect(() => {
    const onMessage = (rawEvent: MessageEvent) => {
      if (rawEvent.data.source === 'react-devtools-content-script') return

      const event: MessageEvent<MessageToRoot> = rawEvent

      if (event.data.type === 'AddTab') {
        tabRoot.addTab(event.data.url, event.data.title, event.data.switchToTab)
      } else if (event.data.type === 'CloseCurrentTab') {
        tabRoot.closeCurrentTab()
      } else if (event.data.type === 'SetCurrentTab') {
        tabRoot.setCurrentTab(event.data.tab)
      } else if (event.data.type === 'GoToNextOrPreviousTab') {
        tabRoot.goToNextOrPreviousTab(event.data.nextTab)
      } else if (event.data.type === 'SetTabTitle') {
        const tab = findSourceTab(tabRoot, event.source)
        if (tab != null) {
          tabRoot.updateTabEntry(tab, { title: event.data.title })
        }
      } else if (event.data.type === 'SetTabHref') {
        const tab = findSourceTab(tabRoot, event.source)
        if (tab != null) {
          tabRoot.updateTabEntry(tab, { href: event.data.href })
        }
      } else if (event.data.type === 'UpdateHistoryState') {
        const tab = findSourceTab(tabRoot, event.source)
        if (tab != null) {
          const { canGoBack, canGoForward } = event.data
          tabRoot.updateTabEntry(tab, { history: { canGoBack, canGoForward } })
        }
      } else if (event.data.type === 'LoadingFinished') {
        const tab = findSourceTab(tabRoot, event.source)
        if (tab != null) {
          tabRoot.updateTabEntry(tab, { isLoading: false })
        }
      }
    }
    window.addEventListener('message', onMessage)
    return () => window.removeEventListener('message', onMessage)
  }, [tabRoot])
}
